module.exports = __webpack_public_path__ + "img/head-cover.a9196cdc.jpg";